import React, { useState, useEffect } from "react";

// IMPORTA TUS IMÁGENES AQUÍ
import mapImage from "../assets/mapacompleto.png";
import dashboardImage from "../assets/dashboard.png";
import reporteImage from "../assets/reporteindividual.png";
import informeImage from "../assets/puntocontrol.png";

const carouselData = [
  {
    img: mapImage,
    alt: "Mapa interactivo",
    title: "Mapa interactivo",
    description:
      "Con alertas en vivo y sistema de notificaciones para todas las áreas operativas.",
  },
  {
    img: dashboardImage,
    alt: "Panel de control",
    title: "Panel de control",
    description:
      "Visualiza el estado general de los servicios y tareas en tiempo real.",
  },
  {
    img: informeImage,
    alt: "Informe con datos",
    title: "Informe con datos",
    description:
      "Evalúa puntos críticos de control y recibe información objetiva para la toma de decisiones.",
  },
  {
    img: reporteImage,
    alt: "Reporte individual",
    title: "Reporte individual",
    description: "Accede a informes detallados de cada proyecto o incidencia.",
  },
];

export const Thirdscreen = () => {
  const [current, setCurrent] = useState(0);
  const total = carouselData.length;
  const [fade, setFade] = useState(true);

  // Auto-slide every 2 seconds with fade effect
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // start fade out
      setTimeout(() => {
        setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1));
        setFade(true); // fade back in
      }, 500); // transition duration (matches CSS below)
    }, 5000);
    return () => clearInterval(interval);
  }, [total]);

  // const prevSlide = () =>
  //   setCurrent((prev) => (prev === 0 ? total - 1 : prev - 1));
  // const nextSlide = () =>
  //   setCurrent((prev) => (prev === total - 1 ? 0 : prev + 1));

  const { img, alt, title, description } = carouselData[current];

  return (
    <div className="flex flex-col justify-center items-center bg-[#EEF5FE] h-[660px] md:h-[800px] font-newFont relative">
      <div className="w-11/12 md:w-4/5 h-[90%] flex flex-col justify-around items-center md:mt-12 md:mb-12 my-8  ">
        {/* Texto */}
        <div
          className={`absolute md:static top-8 left-6 text-left w-[90%] md:w-full transition-opacity duration-500 ease-in-out ${
            fade ? "opacity-100" : "opacity-0"
          }`}
        >
          <h3 className="text-3xl text-primaryBlack font-black">
            <span className="text-primaryBlue">{title.split(" ")[0]}</span>{" "}
            {title.split(" ").slice(1).join(" ")}
          </h3>
          <div className="h-[3px] w-10 bg-primaryBlue mt-5"></div>
          <p className="mt-6 text-xl text-primaryBlack">{description}</p>
        </div>

        {/* Imagen */}
        <div className="flex justify-center items-center w-full md:w-3/5 h-[300px] md:h-[500px] my-4 bg-white rounded-lg shadow-lg overflow-hidden mt-24 md:mt-12 ">
          <img
            src={img}
            alt={alt}
            className={`rounded-lg h-full w-auto object-contain transition-opacity duration-500 ease-in-out ${
              fade ? "opacity-100" : "opacity-0"
            }`}
          />
        </div>

        {/* Dots */}
        <div className="flex gap-2 mt-4 absolute bottom-10 md:bottom-4">
          {carouselData.map((_, index) => (
            <button
              key={index}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                index === current ? "bg-primaryBlue scale-110" : "bg-gray-300"
              }`}
              onClick={() => setCurrent(index)}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};
